<template>
  <!-- 案件材料解析进度：解析期间不可关闭（按需求原型，无关闭按钮）。
       进度与开关由父组件驱动（前端模拟节奏 26% → 62% → 完成） -->
  <div class="overlay" :class="{ show: open }">
    <div class="modal">
      <div class="modal-head"><div class="modal-title">案件材料解析</div></div>
      <div class="modal-body">
        <div class="progress-block">
          <div class="progress-title">AI正在解析案件材料</div>
          <div class="progress-desc">{{ desc }}</div>
          <div class="progressbar"><span :style="{ width: pct + '%' }"></span></div>
          <div class="progress-desc note">解析通常需要几十秒，请稍候。</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  open: Boolean,
  pct: { type: Number, default: 26 },
  // 阶段文案：正在上传案件材料… / 正在解压案件材料
  desc: { type: String, default: "正在解压案件材料" },
});
</script>

<style scoped>
.overlay {
  --brand: #1768ff;
  --line-2: #f0f3f7;
  position: fixed;
  inset: 0;
  background: rgba(18, 31, 53, 0.38);
  z-index: 100;
  display: none;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.overlay.show {
  display: flex;
}
.modal {
  width: min(680px, 92vw);
  max-height: 86vh;
  overflow: hidden;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 24px 70px rgba(20, 36, 64, 0.25);
  border: 1px solid #e6ebf2;
  display: flex;
  flex-direction: column;
}
.modal-head {
  height: 58px;
  border-bottom: 1px solid var(--line-2);
  display: flex;
  align-items: center;
  padding: 0 18px;
  flex: none;
}
.modal-title {
  font-weight: 800;
  font-size: 17px;
}
.modal-body {
  padding: 18px;
  overflow: auto;
}
.progress-block {
  border: 1px solid #dce7fb;
  background: #f8fbff;
  border-radius: 13px;
  padding: 14px;
}
.progress-title {
  font-weight: 800;
  font-size: 14px;
}
.progress-desc {
  font-size: 12px;
  color: #6e7d93;
  margin-top: 6px;
  line-height: 1.65;
}
.progress-desc.note {
  margin-top: 10px;
}
.progressbar {
  height: 8px;
  border-radius: 999px;
  background: #e6edf7;
  overflow: hidden;
  margin-top: 12px;
}
.progressbar span {
  display: block;
  height: 100%;
  background: var(--brand);
  border-radius: 999px;
  transition: width 0.35s;
}
</style>
